/**
 * Data block: reads the active state name from a SceneObject's Properties behavior.
 * Returns an empty string if no state is active (base state).
 */

import { FlowGraphBlock } from "@babylonjs/core/FlowGraph/flowGraphBlock";
import type { FlowGraphContext } from "@babylonjs/core/FlowGraph/flowGraphContext";
import type { IFlowGraphBlockConfiguration } from "@babylonjs/core/FlowGraph/flowGraphBlock";
import { RichTypeString } from "@babylonjs/core/FlowGraph/flowGraphRichTypes";
import { resolveTarget } from './traceContext';
import { Properties } from '../../properties';

export class TraceGetStateBlock extends FlowGraphBlock {
    private _targetPath: string;

    constructor(config?: IFlowGraphBlockConfiguration & { target?: string }) {
        super(config);
        this._targetPath = config?.target ?? '';
        this.registerDataOutput("state", RichTypeString);
    }

    public override _updateOutputs(context: FlowGraphContext): void {
        const target = resolveTarget(context, this._targetPath);
        const props = target?.getBehavior(Properties);
        const state = props?.getActiveState() ?? '';
        this.getDataOutput("state")!.setValue(state, context);
    }

    public override getClassName(): string {
        return "TraceGetStateBlock";
    }
}
